<ngx-spinner></ngx-spinner>
<section class="container-table">
  <div class='row'>
    <div class="col-6">
      <h1 class="mb-0" *ngIf="type!='cali_masterplan'">{{ contentTypeData.edit_title }}</h1>
      <h1 class="mb-0" *ngIf="type=='cali_masterplan'">Editing: {{ recordData.title }}</h1>
    </div>
    <div class="col-6">
      <div class="text-end">
        <button class="btn_primary mb-3" [routerLink]="[backLink]" *ngIf="contentTypeData.hasBackLink">
          Back
        </button>
      </div>
    </div>
  </div>


  <div class="row  " *ngIf="type!='admins'">
    <div class="col-6">
      <h4 class="error fs-6 mt-3">Please Make Sure To Fill Both English & Arabic Fields*</h4>
    </div>
    <div class="btn-group ms-auto" role="group">

      <button type="button" class="btn btn-primary" (click)="lang = 'en'" [ngClass]="{ selected: lang=='en' }" >
        English Editor
      </button>
      <button type="button" class="btn btn-primary" (click)="lang = 'ar'" [ngClass]="{ selected:  lang=='ar'}" *ngIf="contentTypeData.hasArabic">
        Arabic Editor
      </button>
      <button type="button" class="btn btn-primary" (click)="lang = 'comm'" [ngClass]="{ selected: lang=='comm' }"
        *ngIf="contentTypeData.hasCommon"> Common Info </button>
    </div>

  </div>
</section>
<section class="container-table my-3">
  <form [formGroup]="mainForm">
    <div class="section-details">
      <div class="form-group">
        <!-- <div class="row"> -->
        <div class="row pe-5 " *ngIf="lang=='comm' &&  contentTypeData.hasCommon">
          <!-- Render Common Fields -->
          <div class="field col-md-6" *ngFor="let field of contentTypeData.edit_form.common; let i = index">
            <div *ngIf="field.type != 'hidden'"> <label class="form-control-label"
                [ngClass]="{ required: field.required }" [attr.for]="field.label"> {{ field.label }}: </label>
              <div [ngSwitch]="field.type">
                <div class="w-100" appearance="outline" *ngSwitchCase="'checkbox'">
                  <div *ngFor="let opt of field.options" class="form-check form-check"> <label class="form-check-label">
                      <input [formControlName]="field.name" class="form-check-input" (change)="onCheckboxChange($event)"
                        type="checkbox" id="inlineCheckbox1" value=" {{opt.key}}" /> {{opt.label}}</label> </div>
                </div>
                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'text'"> <input matInput
                    placeholder="" formControlName="{{field.name}}" /> </mat-form-field>
                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'dropdown'"> <select matInput
                    class="form-control" [id]="field.name" [formControlName]="field.name">
                    <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.label}}</option>
                  </select> </mat-form-field>
                <div class="w-100" appearance="outline" *ngSwitchCase="'textarea'">
                  <quill-editor [modules]="modules" formControlName="{{field.name}}"></quill-editor>
                </div>
                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'number'">
                  <input matInput  type ="text"  formControlName="{{field.name}}" />
                </mat-form-field>


                <div *ngSwitchCase="'radio'">
                  <div class="form-check" *ngFor="let opt of field.options">
                    <input class="form-check-input" formControlName="{{field.name}}" type="radio" [value]="opt.key">
                    <label class="form-check-label">
                      {{opt.label}}
                    </label>
                  </div>
                </div>

                <div class="img-field" *ngSwitchCase="'file'">
                  <input type="file" (change)="upload($event, field.name)" hidden id="{{field.name+'-field'}}"
                    accept="image/png, image/gif, image/jpeg , image/webp" />
                  <div class="table_image" (click)="triggerClick(field.name+'-field')"
                    [ngClass]="{'replace-img': imageSrc[field.name]!='null'}">
                    <img [src]='renderImage(field.name,section_index)' *ngIf="!imageSrc && !vaildationImageSize"
                      class="img_fit" /> <img [src]="_domSanitizer.bypassSecurityTrustUrl(imageSrc[field.name])" class="img_fit"
                      *ngIf="imageSrc[field.name]!='null' " />
                    <img src="assets/images/no-image-placeholder.png" *ngIf="imageSrc[field.name]=='null'"
                      class="img-fluid" />
                    <div class="text-replace-img" *ngIf="imageSrc[field.name]!='null' ">
                      Replace image
                    </div>
                  </div>                  <small *ngIf="imageSizeError[field.name]"
                  class="text-danger font-14">The image size must not exceed 3MB</small>
                </div>
                <small *ngIf="!mainForm.get(field.name).valid   && mainForm.get(field.name).touched"  class="text-danger font-14">You must enter {{ field.label }}.</small>
                <small
                *ngIf=" backendErrors[field.name]"
                class="text-danger font-14">{{backendErrors[field.name]}}</small>
              </div>
            </div>
          </div>
        </div> <!-- End OF Render Arabic Fields -->
        <div class="row pe-5" [class.d-none]="lang=='ar'">
          <!-- Render English Fields -->
          <div class="field col-md-6" *ngFor="let field of contentTypeData.edit_form.english; let i = index" id="{{field.name+'-container'}}">
            <div *ngIf="field.type != 'hidden'"> <label class="form-control-label"
                [ngClass]="{ required: field.required }" [attr.for]="field.label"> {{ field.label }}: </label>
                <h3 class="error" *ngIf=" type=='offers' && field.name=='button_value'">(If Required)</h3>
                <h3 class="error" *ngIf=" type=='offers' && field.name=='button_content'">(Required if button type is not none)</h3>
              <div [ngSwitch]="field.type">
                <div class="w-100" appearance="outline" *ngSwitchCase="'checkbox'">
                  <div *ngFor="let opt of field.options" class="form-check form-check"> <label class="form-check-label">
                      <input [formControlName]="field.name" class="form-check-input"
                        type="checkbox" id="inlineCheckbox1" value=" {{opt.key}}" /> {{opt.label}}</label> </div>
                </div>

                  <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'date'">

                    <input matInput type="text" name="date" autocomplete="off" bsDatepicker formControlName="{{field.name}}"
                    [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', showWeekNumbers: false}"
                    id="DateOfBirth" placeholder="Select Date"
                    class="form-control" />

                </mat-form-field>

                <div class="d-flex align-items-center " *ngSwitchCase="'button_type'">

                  <mat-list class="list" role="list">
                    <mat-form-field appearance="outline">
                      <mat-label>Select Button Type</mat-label>
                      <mat-select [(value)]="slelectedBtn" formControlName="{{field.name}}">
                        <mat-option *ngFor="let btnType of btnTypes"  [value]="btnType.value">
                            {{btnType.viewValue}}
                        </mat-option>

                      </mat-select>
                    </mat-form-field>
                  </mat-list>


                </div>


                <div class="my-2" *ngSwitchCase="'doc'">
  
                  <input type="file"
                        (change)="upload($event, field.name)" hidden
                          id="{{field.name}}"
                          accept="application/pdf, application/vnd.ms-excel" />

                     <a class="btn_primary" [href]="imageSrc[field.name]"
                      download="{{field.name}}"
                         *ngIf="imageSrc[field.name]!=''"
                     target="_blank">Download</a>
                     <a class="btn_secondary mx-2" (click)="triggerClick(field.name)">Change File</a>
                     <small *ngIf="type=='cali_units'" class="text-danger font-14 d-block my-3">{{dimension?.brochure}}</small>
                </div>




                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'text'"> <input matInput
                    placeholder="" formControlName="{{field.name}}" /> </mat-form-field>
                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'dropdown'"> <select matInput
                    class="form-control" [id]="field.name" [formControlName]="field.name">
                    <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.label}}</option>
                  </select> </mat-form-field>
                  <div *ngIf="type=='baymount_masterplan'">
                    <div class="w-100" appearance="outline" *ngSwitchCase="'textarea'">
                      <quill-editor (keyup)="textChange($event, chars)" [modules]="modules" class="description_editor d-block position-relative" [(ngModel)]="chars" formControlName="{{field.name}}">
                      </quill-editor>
                      <span class="textarea-span description-sm">{{newChars}}/500 Character</span>
                    </div>
                  </div>
                  <div *ngIf="type!='baymount_masterplan'">
                    <div class="w-100" appearance="outline" *ngSwitchCase="'textarea'">
                      <quill-editor [modules]="modules" class="description_editor d-block position-relative" formControlName="{{field.name}}">
                      </quill-editor>
                    </div>
                  </div>

                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'number'">
                  <input matInput  type ="text"  formControlName="{{field.name}}" />
                </mat-form-field>

                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'password'">
                  <input matInput  type ="password"  formControlName="{{field.name}}" />

                </mat-form-field>

                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'confirm'">
                  <input matInput  type ="password"  formControlName="{{field.name}}" />
                  <small *ngIf="mainForm.get('confirmPassword').value!=mainForm.get('password').value && type=='confirm' " class="text-danger font-14">Passwords do not
                    match.</small>
                </mat-form-field>



                <div *ngSwitchCase="'radio'">
                  <div class="form-check col-6" *ngFor="let opt of field.options">
                    <input class="form-check-input" formControlName="{{field.name}}" type="radio" [value]="opt.key" (change)="onCheckboxChange(field.related_to[1], opt.key)">
                    <label class="form-check-label">
                      {{opt.label}}
                    </label>
                  </div>
                </div>
                <div class="img-field" *ngSwitchCase="'file'"> <input type="file" (change)="upload($event, field.name)"
                    hidden id="{{field.name+'-field'}}" accept="image/png, image/gif, image/jpeg, image/webp" />
                  <div class="table_image" (click)="triggerClick(field.name+'-field')"
                    [ngClass]="{'replace-img':imageSrc[field.name]!='null'}">
                    <img [src]='renderImage(field.name,section_index)' *ngIf="!imageSrc && !vaildationImageSize"
                      class="img_fit" /> <img [src]="_domSanitizer.bypassSecurityTrustUrl(imageSrc[field.name])" class="img_fit"
                      *ngIf="imageSrc[field.name]!='null' " />
                    <img src="assets/images/no-image-placeholder.png" *ngIf="imageSrc[field.name]=='null'"
                      class="img-fluid" />
                    <div class="text-replace-img" *ngIf="imageSrc[field.name]!='null' ">
                      Replace image
                    </div>
                  </div>                  <small *ngIf="imageSizeError[field.name]"
                  class="text-danger font-14">The image size must not exceed 3MB</small>
                  <small *ngIf="type=='cali_units_gallery'" class="text-danger font-14">{{dimension.cover_image}}</small>
                </div>
                <small *ngIf="!mainForm.get(field.name).valid   && mainForm.get(field.name).touched"  class="text-danger font-14">You must enter {{ field.label }}.</small>
                <small
                *ngIf=" backendErrors[field.name]"
                class="text-danger font-14">{{backendErrors[field.name]}}</small>
          </div>
            </div>
          </div>
        </div> <!-- End of Render English Fields -->
        <div class="row pe-5 " [class.d-none]="(lang=='en' && contentTypeData.hasArabic)">
          <!-- Render Arabic Fields -->
          <div class="field col-md-6" *ngFor="let field of contentTypeData.edit_form.arabic; let i = index"  id="{{field.name}}-container">
            <div *ngIf="field.type != 'hidden'">
              <label class="form-control-label" [ngClass]="{ required: field.required }" [attr.for]="field.label"> {{
                field.label }}:
              </label>
              <h3 class="error" *ngIf=" type=='offers' && field.name=='button_content_ar'">(Required if button type is not none)</h3>
              <div [ngSwitch]="field.type">
                <div class="w-100" appearance="outline" *ngSwitchCase="'checkbox'">
                  <div *ngFor="let opt of field.options" class="form-check form-check">
                    <label class="form-check-label">
                      <input [formControlName]="field.name" class="form-check-input"
                        type="checkbox" id="inlineCheckbox1" value=" {{opt.key}}" /> {{opt.label}}
                    </label>
                  </div>
                </div>
                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'text'">
                  <input matInput type ="text" placeholder="" formControlName="{{field.name}}" />
                </mat-form-field>


                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'dropdown'">
                  <select matInput
                    class="form-control" [id]="field.name" [formControlName]="field.name">
                    <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.label}}</option>
                  </select> </mat-form-field>
                <div class="w-100" appearance="outline" *ngSwitchCase="'textarea'">
                  <quill-editor [modules]="modules" formControlName="{{field.name}}"></quill-editor>
                </div>
                <mat-form-field class="w-100" appearance="outline" *ngSwitchCase="'number'">
                  <input matInput  type ="text"  formControlName="{{field.name}}" />
                </mat-form-field>


                <div class="my-2" *ngSwitchCase="'doc'">
                  <input type="file"
                        (change)="upload($event, field.name)" hidden
                          id="{{field.name}}"
                          accept="application/pdf, application/vnd.ms-excel" />

                     <a class="btn_primary" [href]="imageSrc[field.name]"
                      download="{{recordData[field.name]}}"
                         *ngIf="imageSrc[field.name]!=''"
                     target="_blank">Download</a>
                     <a class="btn_secondary mx-2" (click)="triggerClick(field.name)">Change File</a>
                 

                </div>

                <div *ngSwitchCase="'radio'">
                  <div class="form-check" *ngFor="let opt of field.options">
                    <input class="form-check-input" formControlName="{{field.name}}" type="radio" [value]="opt.key" >
                    <label class="form-check-label">
                      {{opt.label}}
                    </label>
                  </div>
                </div>
                <div class="img-field" *ngSwitchCase="'file'">
                     <input type="file"
                    (change)="upload($event, field.name)" hidden id="{{field.name+'-field'}}"
                    accept="image/png, image/gif, image/jpeg, image/webp" />
                  <div class="table_image" (click)="triggerClick(field.name+'-field')"
                    [ngClass]="{'replace-img': imageSrc[field.name]!='null'}">
                    <img [src]='renderImage(field.name,section_index)' *ngIf="!imageSrc && !vaildationImageSize"
                      class="img_fit" />
                    <img [src]="_domSanitizer.bypassSecurityTrustUrl(imageSrc[field.name])" class="img_fit" *ngIf="imageSrc[field.name]!='null' " />
                    <img src="assets/images/no-image-placeholder.png" *ngIf="imageSrc[field.name]=='null'"
                      class="img-fluid" />
                    <div class="text-replace-img" *ngIf="imageSrc[field.name]!='null' ">
                      Replace image
                    </div>
                  </div>
                  <small *ngIf="imageSizeError[field.name]"
                  class="text-danger font-14">The image size must not exceed 3MB</small>
                </div>

                <small *ngIf="!mainForm.get(field.name).valid   && mainForm.get(field.name).touched"  class="text-danger font-14">You must enter {{ field.label }}.</small>
                <small
                *ngIf=" backendErrors[field.name]"
                class="text-danger font-14">{{backendErrors[field.name]}}</small>
              </div>
            </div>
          </div>
        </div> <!-- End Of Render Arabic Fields -->
        <!-- </div> -->
      </div>
    </div>
    <div class="form-row"></div>
    <div class="form-group row my-5">
      <div class="col-md-3"></div>
      <div class="col-md-12"> <button type="submit"   (click)="openDialog()" class="btn btn-secondary mx-2">Save
          changes</button> </div>
    </div>
  </form>
</section>
